"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";

export function ContactFormContactUsPageMessages({
  showError = true,
  showSuccess = true,
}) {
  return (
    <Block className={"success-message white"} tag={"div"}>
      {showSuccess ? (
        <Block className={"contact-form-success-white"} tag={"div"}>
          <Paragraph className={"paragraph"}>
            {"Thank you for contacting us. "}
          </Paragraph>
        </Block>
      ) : null}
      {showError ? (
        <Block className={"contact-form-error"} tag={"div"}>
          <Paragraph className={"paragraph-2"}>
            {"Humm. there was an error."}
          </Paragraph>
        </Block>
      ) : null}
    </Block>
  );
}
